<template>
  <div class="wrapper">
    <Header class="header" data-title="고객센터"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="cs">
        <div class="visual faq">
          <p class="tit">
            안녕하세요.
            <br />
            <em>웰몰 고객센터</em>
            입니다.
            <br />
            어떤 도움이 필요하신가요?
          </p>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">FAQ</h2>
            <a class="links arrow txtXS pointC8" @click="$router.push({ name: 'customerCenterFaq', params: { propsKeyword: '' } })">전체 질문 보기</a>
          </div>
          <div class="searchWrap">
            <input type="text" id="ipt1_1" class="ipt" placeholder="궁금한 점을 검색해보세요." title="검색어 입력" value="" v-model="searchInput" />
            <button type="button" class="btnIco_srch" @click="searchFaqForKeyword"><span>검색</span></button>
          </div>
        </section>

        <section class="hr" v-if="userInfo">
          <div class="titArea">
            <h2 class="titH4">1:1 문의하기</h2>
            <a class="links arrow txtXS pointC8" @click="$router.push({ name: 'myQna' })">나의 문의내역 보기</a>
          </div>
          <div class="btnArea">
            <button type="button" class="btn_s m" @click="openMyQnaInsertPop">문의 작성하기</button>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">공지사항</h2>
            <a class="links arrow txtXS pointC8" @click="$router.push({ name: 'customerCenterNotice' })">더보기</a>
          </div>
          <ul class="txtList_disc">
            <li class="ellip" v-for="(notice, noticeIndex) of noticeList" :key="noticeIndex" @click="goNoticeDetail(notice.noticeIndex)">
              <a v-text="notice.title"></a>
            </li>
          </ul>
        </section>

        <section class="full hr mb0">
          <ul class="pageLinkBox btNone">
            <li>
              <a @click="openIntroducePop">웰릭스 서비스 소개</a>
            </li>
          </ul>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">고객센터 상담하기</h2>
          </div>

          <div class="btnArea two half">
            <button type="button" class="btn_s m" @click="kakao">카카오톡 상담</button>
            <button type="button" class="btn_s m" @click="goCellCounseling">
              전화걸기
            </button>
            <button type="button" v-if="incomingType != 'nativeApp' && loginYn != 'N'" class="btn_s m" @click="logout">
              로그아웃
            </button>
          </div>
        </section>
        <CustomerCenterIntroducePop v-if="customerCenterIntroducePop" @close="customerCenterIntroducePop = false"></CustomerCenterIntroducePop>
        <MyQnaInsertPop v-if="myQnaInsertPop" :imgList="imgList" @close="myQnaInsertPop = false"></MyQnaInsertPop>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
//import * as customjs from '../../../../static/js/m.front.js';
import ApiService from '@/common/api.service';
import CustomerCenterIntroducePop from '@/views/app/customerCenter/CustomerCenterIntroducePop';
import MyQnaInsertPop from '@/views/app/mypage/qna/MyQnaInsertPop';
import JwtService from '@/common/jwt.service';

export default {
  name: 'customerCenter',
  components: {
    CustomerCenterIntroducePop,
    MyQnaInsertPop,
  },
  data: function() {
    return {
      userInfo: {}, // 유저정보
      searchInput: null,

      noticeList: [],
      imgList: [],

      customerCenterIntroducePop: null,
      myQnaInsertPop: null,

      incomingType: '',
      loginYn: '',
    };
  },
  created() {
    if (JwtService.getToken()) {
      this.loginYn = 'Y'
    }else{
      this.loginYn = 'N'
    }
    if (navigator.userAgent.match(/RIX/i)) {
      this.incomingType = 'nativeApp';
    }
  },
  mounted() {
    this.userInfo = JwtService.getUserInfo();

    let paramObj = new Object();
    ApiService.service('GET', '/board/noticeMain', paramObj)
      .then(({ data }) => {
        console.log(data);
        if (data.isSucceed) {
          this.noticeList = data.result;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });
  },
  methods: {
    goCellCounseling: function() {
      ApiService.service('GET', '/common/businesshours')
        .then(({ data }) => {
          if (data.isSucceed) {
            if (data.result.businessHourYn == 'Y') window.tel('16700202');
            else this.$router.push('/callService');
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    searchFaqForKeyword: function() {
      this.$router.push({ name: 'customerCenterFaq', params: { propsKeyword: this.searchInput } });
    },
    openIntroducePop: function() {
      //this.customerCenterIntroducePop = true;
      this.$router.push({ name: 'customerCenterIntroduce' });
    },
    openMyQnaInsertPop: function() {
      this.myQnaInsertPop = true;
    },
    goNoticeDetail: function(noticeIndex) {
      this.$router.push({ name: 'customerCenterNoticeDetail', params: { idx: noticeIndex } });
    },
    kakao() {
      if (/iPhone/i.test(navigator.userAgent)) {
        window.iosKakaoTalk();
      } else {
        window.location.href = 'https://pf.kakao.com/_WCcJd/chat';
      }
    },
    logout() {
      JwtService.logout();
      this.$router.replace('/');
    },
  },
};
</script>
